interface Config {
  apiUrl: string;
  API_URL_AU?: string;
  API_URL_UK?: string;
  featureFlags?: Record<string, boolean>;
  REACT_APP_PUBLIC_POSTHOG_KEY?: string;
  REACT_APP_PUBLIC_POSTHOG_HOST?: string;
  APP_VERSION?: string;
}

declare global {
  interface Window {
    config?: Config;
  }
}

export enum FeatureLevel {
  production = 'production',
}

export default {
  ...(window?.config || {}),
  featureLevel: FeatureLevel.production,
};
